
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ranking/[franchiseSlug]/search",
      function () {
        return require("private-next-pages/ranking/[franchiseSlug]/search/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ranking/[franchiseSlug]/search"])
      });
    }
  